var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.997,
    height: 14.998,
    viewBox: "0 0 14.997 14.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filter",
    d: "M14.911,0H1.086A.586.586,0,0,0,.5.586,5.722,5.722,0,0,0,2.419,4.859l2.566,2.28a2.088,2.088,0,0,1,.7,1.559v5.713A.586.586,0,0,0,6.6,14.9l3.456-2.3a.586.586,0,0,0,.261-.487V8.7a2.088,2.088,0,0,1,.7-1.559l2.566-2.28A5.722,5.722,0,0,0,15.5.586.586.586,0,0,0,14.911,0ZM12.8,3.983,10.234,6.264A3.26,3.26,0,0,0,9.141,8.7v3.1L6.856,13.317V8.7A3.26,3.26,0,0,0,5.763,6.264L3.2,3.983A4.551,4.551,0,0,1,1.71,1.172H14.288A4.55,4.55,0,0,1,12.8,3.983Zm0,0",
    transform: "translate(-0.5)",
    fill: "#58618d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fd7ab595b7f9de18af3cee9d42ba01fa.svg";
export { ForwardRef as ReactComponent };